export const TIMEZONE_OPTIONS = [
    { label: "Eastern Time", value: "US/Eastern" },
    { label: "Central Time", value: "US/Central" },
    { label: "Mountain Time", value: "US/Mountain" },
    { label: "Pacific Time", value: "US/Pacific" },
    { label: "Alaska Time", value: "US/Alaska" },
    { label: "Hawaii Time", value: "US/Hawaii" },
] as const;

export const VALID_TIMEZONES: string[] = TIMEZONE_OPTIONS.map((tz) => tz.value);

export const DEFAULT_TIMEZONE = "US/Eastern";

/** Validate a timezone string, returning DEFAULT_TIMEZONE if invalid or null. */
export function validateTimezone(tz: string | null | undefined): string {
    return tz && VALID_TIMEZONES.includes(tz) ? tz : DEFAULT_TIMEZONE;
}
